import Vue from 'vue';
import querystring from 'querystring';
import * as Cursos from '@lib/Cursos';
import { Curso } from '@lib/Cursos/Curso.nav';
import { Watch } from 'vue-property-decorator';
import { Paginacion, Wait } from '@/__env/ext';
import { Controlador as Model } from './controlador';
import { SignalDispatcher, SimpleEventDispatcher } from 'strongly-typed-events';
import { EventBus, Utiles, } from '@/__env/pluggins/event-bus';
import { isNumber } from 'util';


export class ControladorDeCurso
{
    public get Controlador() { return Model; }
    public Curso: Curso = new Curso();


    public async Iniciar( curso: number | Curso )
    {
        this.Vista.Estado = 'cargando';
        if ( isNumber( curso ) )
        {
            this.Curso = await Curso.create( curso );
        } else
        {
            this.Curso = curso;
        }

        if ( !this.Curso )
        {
            Utiles.Notificaciones.Error( 'No se encontro el recurso' );
            this.Cancelar();
        }
        this.Vista.Estado = 'ok';
        this.Vista.Query = this.Curso.Existe ? 'id=' + this.Curso.Id : '' + 'modo=crear&item=nuevo';

    }

    public async Cancelar()
    {
        this.Controlador.Vista.Modo = 'lista';
    }

    private _onGuardar = new SignalDispatcher();
    public get onGuardar() { return this._onGuardar.asEvent(); }
    public async Guardar()
    {
        this._onGuardar.dispatch();
        await Wait( 100 );

        if ( !this.Curso.Titulo || !this.Curso.Descripcion )
        {
            Utiles.Notificaciones.Info( 'Completá el titulo y la descripción' );
            return;
        }
        if ( !this.Curso.Preguntas.hasRows() )
        {
            Utiles.Notificaciones.Info( 'Agrega al menos una pregunta' );
            return;
        }

        this.Vista.Estado = 'cargando';
        let e = await this.Curso.save();
        if ( e )
        {
            this.Vista.Estado = 'ok';

            Utiles.Notificaciones.Completado( 'Guardado correctamente' );
            this.Cancelar();
        }
        else
        {
            this.Vista.Estado = 'ok';
            Utiles.Notificaciones.Error( 'Error al guardar' );
        }
    }
    public readonly Vista = new Vista();
}

type Modo =
    string |
    'vacio' |
    'lista' |
    'crear'

    ;

type SubModo =
    'vacio' |
    'configuracion-usuario' |
    'notificaciones';
'chat'
    ;

type Estado = 'ok' | 'cargando' | 'error';

class Vista
{
    protected query: string = '';
    public set Query( x: string )
    {
        this.query = x;
        Utiles.setQuery( this.query );
    }
    protected estado: Estado = 'cargando';
    get Estado(): Estado { return this.estado; }
    set Estado( m: Estado ) { this.estado = m; this._onEstado.dispatch(); }
    private _onEstado = new SignalDispatcher();
    public get onEstado() { return this._onEstado.asEvent(); }
}


const Controlador = new ControladorDeCurso();
export { Controlador };

